import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services';

@Component({
  selector: 'app-forbidden',
  standalone: false,
  templateUrl: './forbidden.html',
  styleUrls: ['./forbidden.css'],
})
export class ForbiddenComponent {
  constructor(
    private router: Router,
    private auth: AuthService
  ) {}

  goBack(): void {
    if (this.auth.hasValidSession()) {
      void this.router.navigate(['/dashboard']);
    } else {
      void this.router.navigate(['/login']);
    }
  }
}
